export default function Support() {
  return (
    <aside className="fixed right-0 top-1/2 flex flex-col z-50 bg-white/80 backdrop-blur-sm rounded-l-xl border -translate-y-1/2 shadow-xl">
      <div className="w-12 h-12 flex justify-center items-center hover:bg-alice-blue">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.39417 29.3908L4.29701 22.4433C3.12146 20.4052 2.50398 18.0932 2.50682 15.7404C2.50991 8.34777 8.52596 2.33356 15.9188 2.33356C19.5063 2.33538 22.8736 3.73148 25.406 6.26575C27.9385 8.80002 29.3318 12.1686 29.3305 15.7512C29.3273 23.1433 23.3103 29.1586 15.9186 29.1586H15.9128C13.6683 29.1577 11.4629 28.5946 9.5039 27.5264L2.39417 29.3908Z"
            fill="white"
          />
          <path
            d="M15.9228 4.59842C9.77386 4.59842 4.77332 9.59714 4.77113 15.7413C4.7681 17.8394 5.35892 19.8955 6.47529 21.6719L6.74051 22.0935L5.61418 26.2054L9.83329 25.0991L10.2407 25.3405C11.9518 26.356 13.9137 26.893 15.9144 26.8941H15.9186C22.0628 26.8941 27.0633 21.8948 27.0657 15.7503C27.0703 14.2857 26.7844 12.8348 26.2245 11.4815C25.6646 10.1283 24.8418 8.8995 23.8038 7.86637C22.7715 6.8276 21.5434 6.0039 20.1906 5.44295C18.8379 4.882 17.3873 4.59495 15.9228 4.59842Z"
            fill="url(#paint0_linear_121_6213)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5665 10.1354C12.3153 9.57745 12.051 9.56614 11.8124 9.55648L11.17 9.54865C10.9466 9.54865 10.5835 9.63249 10.2765 9.96789C9.96954 10.3033 9.10352 11.1139 9.10352 12.7626C9.10352 14.4114 10.3044 16.0045 10.4717 16.2284C10.6391 16.4522 12.79 19.9435 16.1963 21.2867C19.027 22.403 19.603 22.181 20.2176 22.1252C20.8323 22.0694 22.2003 21.3146 22.4794 20.5321C22.7585 19.7495 22.7586 19.0791 22.675 18.9389C22.5913 18.7987 22.3678 18.7154 22.0324 18.5477C21.697 18.38 20.0497 17.5694 19.7426 17.4575C19.4355 17.3456 19.2122 17.29 18.9885 17.6254C18.7648 17.9608 18.1234 18.7153 17.9278 18.9389C17.7322 19.1626 17.537 19.1906 17.2016 19.0231C16.8662 18.8556 15.7871 18.5016 14.5067 17.36C13.5106 16.4717 12.8381 15.3747 12.6423 15.0395C12.4466 14.7043 12.6216 14.5228 12.7896 14.3558C12.94 14.2056 13.1247 13.9644 13.2925 13.7688C13.4604 13.5733 13.5157 13.4334 13.6272 13.2101C13.7388 12.9869 13.6832 12.7907 13.5993 12.6232C13.5155 12.4557 12.8644 10.7984 12.5665 10.1356"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_121_6213"
              x1="15.6915"
              y1="5.93637"
              x2="15.8045"
              y2="24.9894"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#57D163" />
              <stop offset="1" stop-color="#23B33A" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="w-12 h-12 flex justify-center items-center hover:bg-alice-blue">
        <svg
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_121_6211)">
            <path
              d="M32.9156 23.2962C32.9156 25.825 31.9066 28.2502 30.1105 30.0383C28.3145 31.8264 25.8785 32.8309 23.3385 32.8309C20.7985 32.8309 18.3626 31.8264 16.5665 30.0383C14.7705 28.2502 13.7615 25.825 13.7615 23.2962C13.7615 20.7674 14.7705 18.3422 16.5665 16.5541C18.3626 14.766 20.7985 13.7615 23.3385 13.7615C25.8785 13.7615 28.3145 14.766 30.1105 16.5541C31.9066 18.3422 32.9156 20.7674 32.9156 23.2962Z"
              fill="url(#paint0_linear_121_6211)"
            />
            <path
              d="M46.2626 36.9889C46.2626 38.2414 46.0148 39.4817 45.5333 40.6389C45.0519 41.7961 44.3462 42.8476 43.4566 43.7333C42.567 44.619 41.5108 45.3215 40.3485 45.8008C39.1862 46.2802 37.9404 46.5269 36.6823 46.5269C34.1414 46.5269 31.7046 45.522 29.9079 43.7333C28.1113 41.9445 27.1019 39.5185 27.1019 36.9889C27.1019 34.4592 28.1113 32.0332 29.9079 30.2445C31.7046 28.4558 34.1414 27.4509 36.6823 27.4509C37.9404 27.4509 39.1862 27.6976 40.3485 28.1769C41.5108 28.6562 42.567 29.3588 43.4566 30.2445C44.3462 31.1302 45.0519 32.1816 45.5333 33.3388C46.0148 34.496 46.2626 35.7363 46.2626 36.9889Z"
              fill="url(#paint1_linear_121_6211)"
            />
            <path
              opacity="0.05"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.7965 24.1121C13.9453 25.9136 14.602 27.6361 15.6907 29.0801C16.7793 30.5241 18.2553 31.6303 19.9476 32.2707C21.6399 32.9111 23.4792 33.0594 25.2524 32.6984C27.0255 32.3374 28.66 31.482 29.9665 30.2311C31.2729 28.9803 32.1977 27.3852 32.6338 25.6309C33.0699 23.8765 32.9994 22.0346 32.4305 20.3186C31.8616 18.6026 30.8175 17.0828 29.4193 15.9352C28.0211 14.7877 26.326 14.0593 24.5304 13.8347C22.0923 14.6493 19.8652 15.9935 18.0092 17.7705C16.1532 19.5476 14.7145 21.7133 13.7965 24.1121V24.1121Z"
              fill="black"
            />
            <path
              opacity="0.05"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M46.2375 36.3041C46.1124 34.4806 45.4671 32.731 44.3779 31.2624C43.2887 29.7937 41.8012 28.6674 40.0913 28.0166C38.3814 27.3659 36.5208 27.2179 34.7293 27.5902C32.9379 27.9625 31.2907 28.8396 29.9826 30.1176C28.6745 31.3956 27.7602 33.0211 27.3479 34.8019C26.9355 36.5826 27.0424 38.444 27.6558 40.166C28.2692 41.888 29.3635 43.3985 30.8093 44.5187C32.2551 45.639 33.9919 46.3222 35.8142 46.4875C38.1856 45.6441 40.3457 44.2967 42.1452 42.5384C43.9448 40.78 45.341 38.6526 46.2375 36.303V36.3041Z"
              fill="black"
            />
            <path
              opacity="0.1"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.2448 26.292C14.7478 27.8292 15.6329 29.2137 16.8173 30.3163C18.0016 31.4188 19.4466 32.2033 21.017 32.5963C22.5874 32.9894 24.232 32.9781 25.7969 32.5637C27.3618 32.1493 28.7959 31.3451 29.9651 30.2265C31.1343 29.1079 32.0003 27.7114 32.4823 26.1676C32.9642 24.6237 33.0463 22.983 32.7209 21.3988C32.3954 19.8147 31.6731 18.3389 30.6214 17.1094C29.5697 15.8799 28.223 14.937 26.7073 14.3687C23.7203 14.9903 20.9683 16.4377 18.7648 18.5458C16.5614 20.6539 14.9952 23.338 14.2448 26.292V26.292Z"
              fill="black"
            />
            <path
              opacity="0.1"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.8023 34.0629C45.3067 32.5076 44.4208 31.1048 43.2291 29.9881C42.0374 28.8714 40.5794 28.0779 38.9939 27.6831C37.4085 27.2882 35.7482 27.3052 34.1711 27.7324C32.5941 28.1596 31.1527 28.9829 29.9841 30.1237C28.8156 31.2646 27.9587 32.6852 27.4951 34.2503C27.0315 35.8154 26.9765 37.473 27.3354 39.0654C27.6944 40.6577 28.4552 42.1318 29.5456 43.3474C30.6361 44.5631 32.0197 45.4797 33.565 46.0102C36.5138 45.3492 39.2202 43.8816 41.3814 41.7716C43.5426 39.6616 45.0733 36.9925 45.8023 34.0629V34.0629Z"
              fill="black"
            />
            <path
              opacity="0.1"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.5968 27.1964C15.2199 28.5989 16.1719 29.831 17.3722 30.7885C18.5725 31.7461 19.986 32.4009 21.4931 32.6977C23.0002 32.9946 24.5567 32.9247 26.0311 32.4939C27.5055 32.0632 28.8544 31.2843 29.9638 30.223C31.0733 29.1617 31.9107 27.8493 32.4053 26.3966C32.8999 24.9439 33.0372 23.3936 32.8055 21.8767C32.5739 20.3598 31.9801 18.9209 31.0743 17.6816C30.1685 16.4423 28.9774 15.439 27.6016 14.7565C24.4199 15.2512 21.4668 16.7093 19.1411 18.934C16.8154 21.1586 15.2293 24.0426 14.5968 27.1964V27.1964Z"
              fill="black"
            />
            <path
              opacity="0.1"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.4491 33.14C44.8292 31.7213 43.8737 30.474 42.6648 29.5055C41.4558 28.5369 40.0296 27.876 38.5085 27.5795C36.9875 27.283 35.4171 27.3597 33.9323 27.8032C32.4475 28.2466 31.0926 29.0435 29.9841 30.1253C28.8756 31.2071 28.0466 32.5416 27.5683 34.014C27.09 35.4865 26.9767 37.0529 27.2382 38.5788C27.4996 40.1046 28.1279 41.5442 29.0692 42.774C30.0105 44.0038 31.2366 44.9869 32.6422 45.639C35.796 45.1036 38.7115 43.6205 40.9998 41.3873C43.288 39.1541 44.8401 36.2771 45.4491 33.14V33.14Z"
              fill="black"
            />
            <path
              d="M45.1823 30.2152C45.1823 32.1983 44.79 34.1621 44.0277 35.9943C43.2654 37.8265 42.1481 39.4913 40.7395 40.8936C39.331 42.2959 37.6588 43.4083 35.8184 44.1672C33.9781 44.9261 32.0056 45.3167 30.0136 45.3167C28.0217 45.3167 26.0492 44.9261 24.2088 44.1672C22.3685 43.4083 20.6963 42.2959 19.2878 40.8936C17.8792 39.4913 16.7619 37.8265 15.9996 35.9943C15.2373 34.1621 14.845 32.1983 14.845 30.2152C14.845 28.232 15.2373 26.2682 15.9996 24.436C16.7619 22.6038 17.8792 20.939 19.2878 19.5367C20.6963 18.1344 22.3685 17.0221 24.2088 16.2631C26.0492 15.5042 28.0217 15.1136 30.0136 15.1136C32.0056 15.1136 33.9781 15.5042 35.8184 16.2631C37.6588 17.0221 39.331 18.1344 40.7395 19.5367C42.1481 20.939 43.2654 22.6038 44.0277 24.436C44.79 26.2682 45.1823 28.232 45.1823 30.2152Z"
              fill="url(#paint2_linear_121_6211)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.7483 29.6909C25.1353 29.2879 24.6238 28.7489 24.2537 28.116C23.8963 27.4473 23.7199 26.697 23.742 25.9393C23.7149 24.9777 24.0434 24.0399 24.6648 23.3049C25.3105 22.5669 26.1405 22.013 27.0702 21.6994C28.0814 21.3426 29.1468 21.1634 30.2192 21.1697C30.9209 21.1631 31.6218 21.2168 32.3142 21.3303C32.8098 21.4067 33.2965 21.5322 33.7673 21.7049C34.1996 21.851 34.5898 22.0999 34.9044 22.4301C35.1362 22.7018 35.261 23.0485 35.2554 23.4054C35.2637 23.5909 35.2353 23.7761 35.1719 23.9506C35.1085 24.125 35.0113 24.2853 34.8858 24.4222C34.7672 24.5484 34.6231 24.6481 34.4631 24.7148C34.3031 24.7814 34.1308 24.8135 33.9575 24.8089C33.7191 24.8069 33.4839 24.754 33.2676 24.6538C32.7345 24.4155 32.1854 24.2147 31.6242 24.0531C31.1077 23.917 30.5752 23.8509 30.041 23.8565C29.3448 23.8309 28.656 24.0069 28.0576 24.3633C27.8051 24.5165 27.5984 24.7347 27.4591 24.9951C27.3199 25.2554 27.2532 25.5483 27.266 25.8432C27.2623 26.2303 27.4098 26.6037 27.6771 26.884C27.9947 27.2134 28.3701 27.4817 28.7847 27.6759C29.249 27.9059 29.9415 28.211 30.8621 28.5911C30.9641 28.6234 31.0635 28.6631 31.1595 28.7101C32.058 29.0651 32.9193 29.5074 33.7312 30.0306C34.3724 30.4482 34.9131 31.0025 35.3144 31.6536C35.7096 32.3379 35.9075 33.1181 35.8863 33.9078C35.9195 34.8748 35.6421 35.827 35.0947 36.6252C34.5373 37.3809 33.7661 37.9526 32.8805 38.2667C31.8132 38.6476 30.6854 38.8312 29.5523 38.8084C27.9951 38.8629 26.4454 38.57 25.0158 37.9511C24.6503 37.7885 24.3298 37.5396 24.082 37.2259C23.8762 36.9384 23.7696 36.5919 23.778 36.2385C23.7678 36.0522 23.7982 35.8658 23.8671 35.6924C23.936 35.5189 24.0418 35.3624 24.1771 35.2337C24.4609 34.9856 24.8292 34.8557 25.206 34.8711C25.6259 34.8768 26.0383 34.9828 26.4087 35.1802C26.8694 35.4103 27.2328 35.5829 27.4989 35.6979C27.8027 35.825 28.1174 35.9244 28.4392 35.995C28.8359 36.0819 29.2412 36.1237 29.6474 36.1195C30.3656 36.1707 31.0804 35.9804 31.6778 35.5789C31.9015 35.4041 32.0802 35.1785 32.1992 34.921C32.3183 34.6635 32.3742 34.3813 32.3623 34.0979C32.363 33.696 32.2096 33.3091 31.9337 33.0166C31.569 32.6406 31.1422 32.3302 30.6719 32.0992C30.1157 31.8065 29.3336 31.4497 28.3255 31.0288C27.4238 30.67 26.5605 30.2217 25.7483 29.6909"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_121_6211"
              x="-8"
              y="-8"
              width="76"
              height="76"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_121_6211"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_121_6211"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_121_6211"
              x1="21.8449"
              y1="13.8772"
              x2="24.8256"
              y2="32.7162"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.012" stop-color="#00B7F0" />
              <stop offset="0.339" stop-color="#009DE5" />
              <stop offset="0.755" stop-color="#0082D9" />
              <stop offset="1" stop-color="#0078D4" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_121_6211"
              x1="28.3899"
              y1="41.7704"
              x2="44.9642"
              y2="32.1914"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0078D4" />
              <stop offset="0.37" stop-color="#007AD5" />
              <stop offset="0.573" stop-color="#0082D9" />
              <stop offset="0.735" stop-color="#0090DF" />
              <stop offset="0.875" stop-color="#00A3E7" />
              <stop offset="1" stop-color="#00BCF2" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_121_6211"
              x1="24.094"
              y1="19.9749"
              x2="39.2025"
              y2="46.1723"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#00B7F0" />
              <stop offset="1" stop-color="#007CC1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="w-12 h-12 flex justify-center items-center hover:bg-alice-blue  rounded-bl-xl">
        <svg
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.0289 40.8782L33.0289 40.8782L33.025 40.8833L30.9 43.7166C30.5937 44.1252 30.258 44.2516 30 44.2516C29.7421 44.2516 29.4064 44.1252 29.1 43.7166L26.9786 40.8881C26.7413 40.5651 26.408 40.3344 26.111 40.1871C25.8102 40.0381 25.43 39.9166 25.0417 39.9166H24.3334C21.5177 39.9166 19.7335 39.5474 18.6169 38.5703C17.5333 37.6222 16.8334 35.8721 16.8334 32.4166V25.3333C16.8334 22.6541 17.5025 20.8284 18.6655 19.6654C19.8285 18.5024 21.6542 17.8333 24.3334 17.8333H35.6667C38.3459 17.8333 40.1716 18.5024 41.3346 19.6654C42.4976 20.8284 43.1667 22.6541 43.1667 25.3333V32.4166C43.1667 35.0958 42.4976 36.9216 41.3346 38.0845C40.1716 39.2475 38.3459 39.9166 35.6667 39.9166H34.9584C34.202 39.9166 33.4843 40.279 33.0289 40.8782Z"
            stroke="#00B7F0"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.6616 29.5833H35.6743"
            stroke="#00B7F0"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.9936 29.5833H30.0064"
            stroke="#00B7F0"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.3256 29.5833H24.3383"
            stroke="#00B7F0"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </aside>
  );
}
